export class Claim {
    Id:Number;
    Name:string;
    IsTextEnabled:boolean;

   }